var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4199 27.4897C58.4199 25.4909 56.7879 23.8588 54.7891 23.8588H38.6521C36.6533 23.8588 35.0213 22.2268 35.0213 20.228V4.09103C35.0213 2.09224 33.3893 0.460205 31.3905 0.460205H27.3654C25.3666 0.460205 23.7346 2.09224 23.7346 4.09103V20.2234C23.7346 22.2222 22.1025 23.8543 20.1037 23.8543H3.96676C1.96797 23.8543 0.335938 25.4863 0.335938 27.4851V31.5147C0.335938 33.5135 1.96797 35.1456 3.96676 35.1456H20.1037C22.1025 35.1456 23.7346 36.7776 23.7346 38.7764V54.9088C23.7346 56.9076 25.3666 58.5396 27.3654 58.5396H31.3905C33.3893 58.5396 35.0213 56.9076 35.0213 54.9088V38.7764C35.0213 36.7776 36.6533 35.1456 38.6521 35.1456H54.7891C56.7879 35.1456 58.4199 33.5135 58.4199 31.5147V27.4897Z",
    fill: "#D71524"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.123a1b99b46d2fa9ad0543b0164fb021.svg";
export { ForwardRef as ReactComponent };